<template>
  <div class="pay-fail">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" :to="to" :transparent="true" />
    <!-- 购买失败 -->
    <div class="pay-status">
      <iconfont class="icon-status iconwrong" />
      <div class="course-text">
        <div class="course-success">购买遇到问题了~</div>
      </div>
    </div>
    <!-- 用户 -->
    <PayUser :user="payStatus" :success="false">
      <!-- 重新购买 -->
      <form-submit facade="radius" type="primary" size="small" text="重新购买" @submit="reBuy" />
    </PayUser>
  </div>
</template>

<script>
// 商品订单的失败页面
import { mapGetters } from 'vuex'
import PayUser from './components/pay-user'
export default {
  name: 'pay-fail',
  components: { PayUser },
  data() {
    return {
      title: ''
    }
  },
  computed: {
    ...mapGetters('payment/order', [
      'payStatus' // 支付状态
    ]),
    to() {
      return {
        name: 'confirmOrder',
        params: this.$route.params
      }
    }
  },
  methods: {
    reBuy() {
      this.$router.replace(this.to)
    }
  }
}
</script>

<style lang="scss" scoped>
.pay-fail {
  background: url("../../../images/payment/success_BG.png") no-repeat;
  background-color: #f7f9fb;
  background-size: 100% 40%;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  .pay-status {
    font-size: 18px;
    font-weight: bold;
    margin: 30px 0;
    color: white;
    .icon-status {
      display: inline-block;
      font-size: 48px;
      margin-bottom: 20px;
      opacity: 0.5;
    }
    // 课程引导
    .course-text {
      .course-success {
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        opacity: 1;
      }
    }
  }
  .form-submit {
    margin-top: 40px;
  }
}
</style>
